import type { DoorWirelessLockSource } from '../types';

export const doorHasWirelessLock = (door?: DoorWirelessLockSource | null): boolean =>
  door?.type === 'wireless' || !!door?.accessInventory?.catalog?.AccessCatalogCapabilities?.hasWirelessReaders;
